import React, { FC } from 'react'
import { Tag, TagProps } from 'antd'
import styled from 'styled-components'

import { pickTextColor } from 'src/utils/color'

type Variants = `default` | `bordered`

type StyledComponentTagProps = {
  $bold?: boolean
  variant?: Variants
}

export type StyledTagProps = StyledComponentTagProps & TagProps

const variants: Record<
  Variants,
  (args: StyledComponentTagProps & Pick<TagProps, 'color'>) => string
> = {
  default: ({ $bold, color }) => `
    color: ${pickTextColor(color || 'white')};
    background-color: ${color};
    border: solid ${$bold ? 2 : 1}px color-mix(in srgb, ${color}, black);`,
  bordered: ({ $bold, color }) => `
    background-color: white !important;
    border: solid ${$bold ? 2 : 1}px ${color};
    color: ${color};
  `,
}

const StyledComponentTag = styled(Tag)<StyledComponentTagProps>`
  &&& {
    ${({ $bold }) => ($bold ? `font-weight: bold;` : ``)}
    ${({ variant = `default`, color, $bold }) =>
      variants[variant]({ color, $bold })}
  }
`

const StyledTag: FC<StyledTagProps> = ({
  children,
  color,
  $bold = false,
  variant = 'default',
  ...rest
}) => {
  return (
    <StyledComponentTag {...rest} color={color} $bold={$bold} variant={variant}>
      {children}
    </StyledComponentTag>
  )
}

export default StyledTag
